

















import Vue from 'vue'
import { adjustDateToJp } from '@/utils'

export default Vue.extend({
  name: 'ItemCard',
  props: {
    id: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    author: {
      type: String,
      required: true
    },
    point: {
      type: Number,
      required: true
    },
    thumb: {
      type: String,
      required: true
    },
    hasUsed: {
      type: Boolean,
      required: false,
      default: false
    },
    usedAt: {
      type: String,
      required: false,
      default: ''
    },
    date: {
      type: String,
      required: true
    },
    link: {
      type: String,
      required: true
    }
  },
  computed: {
    usedClass(): string {
      const className = this.hasUsed ? 'is-used' : ''
      return className
    },
    adjustDate(): string {
      return adjustDateToJp(this.date)
    },
    hasUsedLabel(): string {
      const label = this.hasUsed ? '使用済み' : '未使用'
      return label
    }
  },
  methods: {
    handleClick() {
      this.$emit('handleClick', { id: this.id, hasUsed: this.hasUsed, usedAt: this.usedAt })
      this.$router.push(this.link)
    }
  }
})
